"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectInsertMultiConcentrationLimitLpSlugRecordSchema = exports.DirectInsertConcentrationLimitRecordSchema = exports.DirectInsertEligibilityTestRecordSchema = exports.DirectInsertBorrowingBaseReportLpSlugRecordSchema = exports.ReceivableWaiverTestKeyStringsSchema = exports.ComplianceStatusSchema = void 0;
const zod_1 = require("zod");
const DbTables_1 = require("./DbTables");
var DbTables_2 = require("./DbTables");
Object.defineProperty(exports, "ComplianceStatusSchema", { enumerable: true, get: function () { return DbTables_2.ComplianceStatusSchema; } });
// Zod schema for ReceivableWaiverTestKeyStrings
exports.ReceivableWaiverTestKeyStringsSchema = zod_1.z.object({
    externalReceivableId: zod_1.z.string(),
    borrowingBaseTestKeys: zod_1.z.string(),
});
// ============================================================================
// DIRECT INSERT BORROWING BASE REPORT LP SLUG RECORD SCHEMA
// ============================================================================
exports.DirectInsertBorrowingBaseReportLpSlugRecordSchema = zod_1.z.object({
    loanProductSlug: zod_1.z.string(),
    totalReceivableExposure: zod_1.z.number(),
    assetValuation: zod_1.z.number(),
    totalEligibleExposure: zod_1.z.number(),
    totalEligibilityKickout: zod_1.z.number(),
    eligibleExposureLessConcentrationKickouts: zod_1.z.number(),
    totalConcentrationKickout: zod_1.z.number(),
    borrowingBaseAmount: zod_1.z.number(),
    performingExposure: zod_1.z.number(),
});
// ============================================================================
// DIRECT INSERT ELIGIBILITY TEST RECORD SCHEMA
// ============================================================================
exports.DirectInsertEligibilityTestRecordSchema = zod_1.z.object({
    eligibilityCriteriaKey: zod_1.z.string(),
    eligibilityReduction: zod_1.z.number(),
});
// ============================================================================
// DIRECT INSERT CONCENTRATION LIMIT RECORD SCHEMA
// ============================================================================
exports.DirectInsertConcentrationLimitRecordSchema = zod_1.z.object({
    concentrationLimitKey: zod_1.z.string(),
    concentrationLimit: zod_1.z.number(),
    concentrationAmount: zod_1.z.number(),
    totalEligibleExposure: zod_1.z.number(),
    concentration: zod_1.z.number(),
    borrowingBaseReduction: zod_1.z.number(),
    /**
     * COMPLIANT
     * LIMIT_WARNING
     * LIMIT_REACHED
     * WAIVED
     * if omitted, uses borrowingBaseReduction === 0 ? 'COMPLIANT' : 'LIMIT_REACHED'
     */
    complianceStatus: DbTables_1.ComplianceStatusSchema.optional(),
});
// ============================================================================
// DIRECT INSERT MULTI CONCENTRATION LIMIT LP SLUG RECORD SCHEMA
// ============================================================================
exports.DirectInsertMultiConcentrationLimitLpSlugRecordSchema = zod_1.z.object({
    concentrationLimitKey: zod_1.z.string(),
    borrowingBaseReduction: zod_1.z.number(),
    loanProductSlug: zod_1.z.string(),
});
//# sourceMappingURL=BorrowingBase.js.map